import type { MatchConfig } from "./types";

/** Standaardwaarden (allemaal configureerbaar; zie docs/opdracht). */
export const DEFAULT_CONFIG: Omit<MatchConfig, "teams"> = {
  bestOf: 3,
  setTargets: [21, 21, 15],
  minLead: 2,
  sideSwitchEvery: { normal: 7, thirdSet: 5 },
  highConfidence: 0.88,
  mediumConfidence: 0.65,
  authoritativeServeConfidence: 0.88,
  confirmServeConfidence: 0.65,
};

export function defaultTeams(): MatchConfig["teams"] {
  return {
    A: { name: "Team A", players: ["Speler A1", "Speler A2"] },
    B: { name: "Team B", players: ["Speler B1", "Speler B2"] },
  };
}

export function defaultConfig(): MatchConfig {
  return { ...DEFAULT_CONFIG, teams: defaultTeams() };
}

export function assertConfig(cfg: MatchConfig): void {
  if (!(cfg.bestOf >= 1)) throw new Error("bestOf moet >= 1 zijn");
  if (cfg.setTargets.length !== 3) throw new Error("setTargets moet [21,21,15]-achtig zijn");
  if (!(cfg.minLead >= 1)) throw new Error("minLead moet >= 1 zijn");
  if (!(cfg.highConfidence > cfg.mediumConfidence)) {
    throw new Error("highConfidence moet groter zijn dan mediumConfidence");
  }
  if (!(cfg.authoritativeServeConfidence >= 0 && cfg.authoritativeServeConfidence <= 1)) {
    throw new Error("authoritativeServeConfidence moet in [0,1] liggen");
  }
  if (!(cfg.confirmServeConfidence >= 0 && cfg.confirmServeConfidence <= 1)) {
    throw new Error("confirmServeConfidence moet in [0,1] liggen");
  }
  if (cfg.sideSwitchEvery.normal < 1 || cfg.sideSwitchEvery.thirdSet < 1) {
    throw new Error("Kantwisseldrempels moeten >= 1 zijn");
  }
}
